import { render, staticRenderFns } from "./NarrativeDetail.vue?vue&type=template&id=72f6d34b&scoped=true&"
import script from "./NarrativeDetail.vue?vue&type=script&lang=js&"
export * from "./NarrativeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f6d34b",
  null
  
)

export default component.exports